import { motion as Motion } from 'framer-motion'
import { useSelector } from 'react-redux'
import SessionExpiredOverlay from './SessionExpiredOverlay'
import BuyBonusOverlay from '@components/buyBonus/BuyBonusOverlay'

const OverlayController = () => {
  const authenticationStatus = useSelector((state) => state.session.authenticationStatus)
  const buyBonusOpen = useSelector((state) => state.ui.buyBonus.open)

  // Priority order: a dead session blocks everything else, including a
  // purchase in progress.
  const renderOverlay = () => {
    if (authenticationStatus === 'FAILED') return <SessionExpiredOverlay />
    if (buyBonusOpen) return <BuyBonusOverlay />
    return null
  }

  const activeOverlay = renderOverlay()

  if (!activeOverlay) return null

  return (
    <div className="overlay-root">
      <Motion.div
        className="overlay-backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.1, ease: 'easeOut' }}
      />

      <Motion.div
        className="overlay-container"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        {activeOverlay}
      </Motion.div>
    </div>
  )
}

export default OverlayController
